import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

function AppUrlHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const listener = CapacitorApp.addListener("appUrlOpen", (event) => {
        console.log("APP URL OPEN:", event.url);
        const url = new URL(event.url);
        console.log("pathname:", url.pathname);
        if (url.pathname.startsWith("/share/")) {
          navigate(url.pathname);
        }
      });

      CapacitorApp.getLaunchUrl().then((data) => {
        if (data?.url) {
          const url = new URL(data.url);
          if (url.pathname.startsWith("/share/")) {
            navigate(url.pathname);
          }
        }
      });

      return () => {
        listener.remove();
      };
    }
  }, [navigate]);

  return null;
}

export default AppUrlHandler;
